import { Stack, stackingOrder } from '@alfa-bank/site-stack';
import type { FC } from 'react';
import React, { useEffect } from 'react';
// TODO: https://jira.moscow.alfaintra.net/browse/ALFABANKRU-83779
// eslint-disable-next-line package-imports/no-core-components-imports
import { Badge } from '@alfalab/core-components-badge';
import { InformationCircleMIcon } from '@alfalab/icons-glyph/InformationCircleMIcon';
import cn from 'classnames';

import type { TNoDeliveryPlate } from './models';

export const NoDeliveryPlate: FC<TNoDeliveryPlate> = ({
    Plate,
    Text,
    isShown,
    noDeliveryAlertText,
    onClose,
    styles,
    textPreset,
}) => {
    useEffect(() => {
        if (isShown) {
            const timeoutID = setTimeout(() => {
                onClose();
            }, noDeliveryAlertText.timeout);

            return () => {
                clearTimeout(timeoutID);
            };
        }
    }, [noDeliveryAlertText.timeout, isShown, onClose]);

    if (!isShown) {
        return null;
    }

    return (
        <Stack value={stackingOrder.OVERLAY}>
            {zIndex => (
                <div
                    className={cn(styles?.external, styles?.errorPlate)}
                    style={{ zIndex, position: 'fixed' }}
                >
                    <Plate
                        className={cn(styles?.external, styles?.plate)}
                        contentClassName={cn(styles?.external, styles?.errorPlateContent)}
                        hasCloser
                        leftAddons={
                            <Badge
                                content={<InformationCircleMIcon />}
                                iconColor="negative"
                                view="icon"
                            />
                        }
                        onClose={onClose}
                        view="negative"
                    >
                        <Text styler={{ margin: 0, padding: 0 }} view={textPreset.noDeliveryTitle}>
                            {noDeliveryAlertText.title}
                        </Text>
                        <Text
                            styler={{ margin: 0, padding: 0, paddingTop: 8 }}
                            view="primary-small"
                        >
                            {noDeliveryAlertText.subtitle}
                        </Text>
                    </Plate>
                </div>
            )}
        </Stack>
    );
};
